import http from "@/http-common";
import { router } from "../router/index.js";
import security from "@/services/security";

http.interceptors.request.use(
  config => {
    // Interceptamos cada petición que realizamos por Axios
    // para que incluya el token y el SSID en el header
    var token = localStorage.getItem('jwt');
    if (token) {
      config.headers['x-access-token'] = token
    }

    return config
  },

  error => {
    return Promise.reject(error)
  }

)

http.interceptors.response.use(undefined, function(err) {
  if (err.response.status === 401 ) {
    // if you ever get an unauthorized, logout the user
    //window.location.href = '/user/logout'
    router.push({name: "logout"});
  }

  if(err.response.status !== 200){
    security.errorHttpHandler(err);
  }

  //return err;
  throw err;
});

export default {
  getConfig() {
    var user = JSON.parse(localStorage.getItem('user'));
    var ssid = user["ssid"];

    var config = {
      headers: {
        jwt: localStorage.getItem('jwt'),
        ssid: ssid
      }
    }
    return config;
  },

  errorHttpHandler(error){
    let err ={};
    try {
      if (error.response){
        err.url = error.response.request.responseURL;
        err.httpStatus = error.response.status;
        err.httpMessage = error.response.statusText;
        err.data = error.response.data;
      }

      console.error("ERROR API - HTTP response");
      console.trace(err);
    } catch (error) {
      console.trace("ERROR: security.js - errorHttpHandler");
    }
    return err;  
  }
} 